import { c as _c } from "react/compiler-runtime";
import { allGroupsFetchingSelector } from "@store/groups/groups-selector";
import { fetchGroups } from "@store/groups/groups-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";

/**
 * Returns a function that fetches all the groups of the company, unless they are already fetched or
 * being fetched, so the components that only need the groups once can share them. It fetches them
 * again for another company, or after they failed to be fetched, which the errors slice already
 * shows a toast for.
 */
export function useFetchGroupsOnce(companyId) {
  const $ = _c(5);
  const dispatch = useAppDispatch();
  const allGroupsFetching = useAppSelector(allGroupsFetchingSelector);
  let t0;
  if ($[0] !== allGroupsFetching.companyId || $[1] !== allGroupsFetching.status || $[2] !== companyId || $[3] !== dispatch) {
    t0 = () => {
      const hasFetchedGroups = allGroupsFetching.companyId === companyId && (allGroupsFetching.status === "pending" || allGroupsFetching.status === "succeeded");
      if (!companyId || hasFetchedGroups) {
        return;
      }
      dispatch(fetchGroups({
        companyId
      }));
    };
    $[0] = allGroupsFetching.companyId;
    $[1] = allGroupsFetching.status;
    $[2] = companyId;
    $[3] = dispatch;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}